import { Link } from 'react-router-dom';

import { Button } from '@/_shared/components/ui/button';

type Tone = 'primary' | 'quiet';

const TONE_CLASSES: Record<Tone, string> = {
  primary: 'text-xs text-primary underline-offset-4 hover:underline',
  quiet: 'text-xs text-muted-foreground underline-offset-4 hover:text-foreground hover:underline',
};

/** The small underlined link the gateway cards use for a secondary route. */
export function TextLink({
  to,
  tone = 'primary',
  children,
}: {
  to: string;
  tone?: Tone;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <Button variant="text" asChild className={TONE_CLASSES[tone]}>
      <Link to={to}>{children}</Link>
    </Button>
  );
}

/** The same look for an in-card action. */
export function TextButton({
  onClick,
  tone = 'quiet',
  loading = false,
  disabled = false,
  children,
}: {
  onClick: () => void;
  tone?: Tone;
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <Button
      type="button"
      variant="text"
      className={TONE_CLASSES[tone]}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
